import React from "react";
import { MButton } from "./MButtons";

interface MDoneProps {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const MDone: React.FC<MDoneProps> = ({
  className: _className = "",
  onClick,
  disabled = false,
}) => {
  return (
    <div className="confirm-footer">
      <MButton
        variant="filled"
        size="lg"
        className="w-full"
        onClick={onClick}
        disabled={disabled}
      >
        Done
      </MButton>
    </div>
  );
};

export default MDone;
